import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link, withRouter } from 'react-router-dom'

//i18n
import { withTranslation } from 'react-i18next'

class LogisticsContent extends Component {
	constructor(props) {
		super(props)
		this.refDiv = React.createRef()
	}

	render() {
		const { t } = this.props

		return (
			<React.Fragment>
				<li>
					<Link to="/#" className="has-arrow">
						<i className="bx bx-line-chart" />
						<span>{t('logistics', { ns: 'naming' })}</span>
					</Link>
					<ul className="sub-menu" aria-expanded="false">
						<li>
							<Link to="/receptions">{t('receptions', { ns: 'naming' })}</Link>
						</li>
						<li>
							<Link to="/expeditions">
								{t('expeditions', { ns: 'naming' })}
							</Link>
						</li>
						<li>
							<Link to="/logistics-shipments">
								{t('shipments', { ns: 'naming' })}
							</Link>
						</li>
						<li>
							<Link to="/boxes">{t('boxes', { ns: 'naming' })}</Link>
						</li>
					</ul>
				</li>
			</React.Fragment>
		)
	}
}

LogisticsContent.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
	type: PropTypes.string,
	initMenu: PropTypes.func,
}

export default withRouter(withTranslation()(LogisticsContent))
